// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toasted{font-family:\"Roboto\",sans-serif;font-size:16px!important;font-weight:500;line-height:22px!important;color:#fff!important}.toasted.toasted-primary.success{background:#3db38c!important}.toasted.toasted-primary.error{background:#db4237!important}.toasted.toasted-primary .action{color:#fafafa!important}", ""]);
// Exports
module.exports = exports;
